import { Button, Col, Row, Spin } from 'antd';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import useStore from 'src/hooks/useStore';
import { IIndividualBorrowerOnboardingStore } from 'src/store/user/individual-borrower-onboarding.store';
import BorrowerCreditHistory from './borrower-credit-history/borrower-credit-history';
import EmploymentDetails from './employment-details/emploment-details';
import FinancialDetails from './financial-details/finacial-details';
import SupportingDocuments from './supporting-documents/supporting-documents';
import { useTranslation } from 'react-i18next';
import { i18nKey } from 'src/locales/i18n';

interface IProps {
	onConfirmForm?: () => void;
	isViewFullForm?: boolean;
}

const BorrowerRequestMortgageDeal = ({ onConfirmForm, isViewFullForm }: IProps) => {
	const [loading, setLoading] = useState(false);

	const [t] = useTranslation();

	const onboardStore: IIndividualBorrowerOnboardingStore = useStore('individualBorrowerOnboardingStore');

	useEffect(() => {
		setLoading(true);
		onboardStore
			.loadProgress()
			.then(() => setLoading(false))
			.catch();
	}, []);

	return (
		<>
			<Spin spinning={loading}>
				<EmploymentDetails />
				<FinancialDetails />
				<BorrowerCreditHistory />
				<SupportingDocuments />
				{!isViewFullForm && (
					<Row
						gutter={[
							{ xs: 0, sm: 0, md: 0, lg: 132 },
							{ xs: 20, sm: 20, md: 20, lg: 16 }
						]}
						style={{ marginTop: 30 }}>
						<Col span={24}>
							<Row gutter={16}>
								<Col span={24}>
									<Button block type="primary" loading={loading} onClick={onConfirmForm}>
										{t(i18nKey.common.submit)}
									</Button>
								</Col>
							</Row>
						</Col>
					</Row>
				)}
			</Spin>
		</>
	);
};

export default observer(BorrowerRequestMortgageDeal);
